<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/62piOg/images/9780292794573.jpg?1689948008107" alt="This image is the cover for the book World War II and Mexican American Civil Rights"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">World War II and Mexican American Civil Rights
      </h1>
      <p class="bookDescription body article font2">
        <b>This historical study examines how Mexican American experiences during WWII galvanized the community’s struggle for civil rights.</b><br/>  <br/> World War II marked a turning point for Mexican Americans that fundamentally changed their relationship to US society at large. The experiences of fighting alongside white Americans in the military, as well as working in factory jobs for wages equal to those of Anglo workers, made Mexican Americans less willing to tolerate the second-class citizenship that had been their lot before the war. Having proven their loyalty and “Americanness” during World War II, Mexican Americans began to demand the civil rights they deserved.<br/>  <br/> In this book, Richard Griswold del Castillo and Richard Steele investigate how the wartime experiences of Mexican Americans helped forge their civil rights consciousness and how the US government responded. The authors demonstrate, for example, that the US government “discovered” Mexican Americans during World War II and began addressing some of their problems as a way of ensuring their willingness to support the war effort.<br/>  <br/> The book concludes with a selection of key essays and historical documents from the World War II period that provide a first-person perspective of Mexican American civil rights struggles.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard Griswold del Castillo
      </h2>
      
      <p class="authorDescription body article">RICHARD GRISWOLD DEL CASTILLO is Professor of Chicana and Chicano Studies at San Diego State University.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      University of Texas Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1f20edf4